<template>
    <div class="sec-cont">
        <Head :title="title"/>
        <div class="max-w-full bg-white rounded-md shadow overflow-hidden p-6">
            <form @submit.prevent="submitForm">

                <!-- Applicant Details Section -->
                <h2 class="text-xl font-bold mb-4">Activity Details</h2>


                <div class="flex flex-wrap -mb-8 -mr-6">
                    <select-input v-model="event_category_id" class="pb-8 pr-6 w-full lg:w-1/6" :label="__('Select Activity')">
                        <option v-for="item in event_categories" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select-input>
                    <text-input class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Title')" v-model="title" type="text"/>
                </div>

                <br>
                <div class="add-draft flex flex-wrap">
                    <div v-for="(topic, topicIndex) in topics" :key="topicIndex" class="topic w-full">
                        <input class="pb-4 pr-6 w-full lg:w-1/2" v-model="topic.name" placeholder="Topic Title"/>
                        <button class="btn-indigo mx-auto" @click="deleteTopic(topicIndex)">Delete Topic</button>
                        <ul>
                            <li v-for="(point, pointIndex) in topic.points" :key="pointIndex">
                                <input class="pb-4 pr-6 w-full lg:w-1/2" :value="point"
                                       @input="updatePoint(topicIndex, pointIndex, $event.target.value)"
                                       placeholder="Point"/>
                                <button class="btn-indigo mx-auto" @click="deletePoint(topicIndex, pointIndex)">Delete
                                    Point
                                </button>
                            </li>
                        </ul>
                        <input type="file" multiple @change="addImages(topicIndex, $event)"/>
                        <div class="images">
                            <img v-for="(image, imgIndex) in topic.images" :key="imgIndex" :src="image" alt="Image"/>
                        </div>
                        <div class="pb-4 pr-6 w-full lg:w-1/2"></div>
                        <button class="btn-indigo mx-auto" type="button" @click="addPoint(topicIndex)">Add Point</button>
                    </div>
                    <!--                    <button @click="addTopic">Add Topic</button>-->
                </div>


                <!-- Submit Button -->
                <div class="flex items-center justify-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <button class="btn-indigo mx-auto" type="button"   @click="addTopic">{{
                            __('Add Topic')
                        }}
                    </button>

                    <loading-button class="btn-indigo mx-auto" type="submit">{{
                            __('Submit')
                        }}
                    </loading-button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import AcademicQualifications from '@/Pages/Interview/AcademicQualifications'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import MultiSelectInput2 from '@/Shared/MultiSelectInput2'
import axios from 'axios'

export default {

    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        AcademicQualifications,
        QuillEditor,
        MultiSelectInput2,
    },
    layout: Layout,
    props:{
        event_categories :{
            required : true,
            type: Array
        }
    },

    data() {
        return {
            title: '',
            topics: [],
            event_category_id:"",
            form: this.$inertia.form({
                processing: false,
                title: "",
                topics: [],
                event_category_id:""
            }),
        }
    },
    watch: {},
    methods: {
        addTopic() {
            this.topics.push({name: '', points: [], images: []})
        },
        deleteTopic(index) {

            this.topics.splice(index, 1)
        },
        addPoint(topicIndex) {
            console.log("addPoint")
            this.topics[topicIndex].points.push('')
        },
        deletePoint(topicIndex, pointIndex) {
            this.topics[topicIndex].points.splice(pointIndex, 1)
        },
        updatePoint(topicIndex, pointIndex, value) {
            this.topics[topicIndex].points[pointIndex] = value
        },
        addImages(topicIndex, event) {
            const files = event.target.files
            Array.from(files).forEach((file) => {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.topics[topicIndex].images.push(e.target.result)
                }
                reader.readAsDataURL(file)
            })
        },
        submitForm() {
            this.form.processing = true
            this.form.title = this.title
            this.form.topics = this.topics
            this.form.event_category_id = this.event_category_id
            this.form.post(this.route('add.draft.data')).then((response) => {
                this.form.reset()
                console.log(response)
                    alert("data succesff")
            }).catch((error) => {
                console.log(error)
            })
        },
    },

}
</script>
